import { create } from "zustand";
import axios from "axios";
import { API_BASE_URL1 } from "../../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../../utils/apiCall";
import { toast } from "react-toastify";
import { persist } from "zustand/middleware";
const MSWManagementSecondaryCollectionStore = create(
  persist(
    (set, get) => ({
      MSWManagementSecondaryCollectionReportData: [],
      MSWManagementSecondaryCollectionInnerReportData: [],
      MSWManagementSecondaryCollectionMonthlyReportData: [],
      ieNameList: [],
      loading: false,
      error: false,

      kpi5outerData: null,
      setkpi5outerData: (newFilters) => set({ kpi5outerData: newFilters }),

      // ================= Outer Report =================
      fetchMSWManagementSecondaryCollectionReport: async (queryParams) => {
        set({ loading: true, error: null });
        const queryString = new URLSearchParams(queryParams).toString();

        try {
          const mswSecondaryReport = await apiCall({
            url: `${API_BASE_URL1}KpiReport/PlannedAndDeployedSecondaryVehiclesSummary?${queryString}`,
            method: "get",
            token: localStorage.getItem("token"),
          });

          const data = Array.isArray(mswSecondaryReport)
            ? mswSecondaryReport
            : [];

          const totals = data.reduce(
            (acc, row) => ({
              plannedVehicleCount:
                acc.plannedVehicleCount +
                (Number(row.plannedVehicleCount) || 0),
              deployedVehicleCount:
                acc.deployedVehicleCount +
                (Number(row.deployedVehicleCount) || 0),
              performanceAchieved:
                acc.performanceAchieved +
                (Number(row.performanceAchieved) || 0),
            }),
            {
              plannedVehicleCount: 0,
              deployedVehicleCount: 0,
              performanceAchieved: 0,
            },
          );

          const totalRow = {
            reportDate: "Total",
            plannedVehicleCount: totals.plannedVehicleCount,
            deployedVehicleCount: totals.deployedVehicleCount,
            performanceAchieved: " ",
            description: " ",
          };

          const finalData = data.length ? [...data, totalRow] : data;

          set({
            MSWManagementSecondaryCollectionReportData: finalData,
            loading: false,
            error: null,
          });
        } catch (error) {
          if (error.response) {
            if (error.response.status === 404) {
              toast.error(error.message);
              set({
                MSWManagementSecondaryCollectionReportData: [],
                error: "No Data found.",
                loading: false,
              });
            } else if (error.response.status === 400) {
              toast.error(error.message || "Bad Request");
              set({
                MSWManagementSecondaryCollectionReportData: [],
                error: error.message || "Bad Request",
                loading: false,
              });
            } else if (error.response.status === 401) {
              toast.error("Unauthorized. Please login again.");
              localStorage.removeItem("token");
              set({
                MSWManagementSecondaryCollectionReportData: [],
                error: "Unauthorized",
                loading: false,
              });
              window.location.href = "/login";
            } else if (error.response.status === 500) {
              toast.error("Internal Server Error");
              set({
                MSWManagementSecondaryCollectionReportData: [],
                error: "Internal Server Error",
                loading: false,
              });
            } else {
              toast.error(error.message || "Something went wrong");
              set({
                MSWManagementSecondaryCollectionReportData: [],
                error: error.message || "Something went wrong",
                loading: false,
              });
            }
          } else {
            set({
              MSWManagementSecondaryCollectionReportData: [],
              error: "Network error. Please try again.",
              loading: false,
            });
          }
        } finally {
          set({ loading: false });
        }
      },

      // ================= Inner Report =================
      fetchMSWManagementSecondaryCollectionInnerReport: async (queryParams) => {
        set({ loading: true, error: null });
        const queryString = new URLSearchParams(queryParams).toString();

        try {
          const mswSecondaryInnerReport = await apiCall({
            url: `${API_BASE_URL1}KpiReport/PlannedAndDeployedSecondaryVehiclesSummaryByZoneCircle?${queryString}`,
            method: "get",
            token: localStorage.getItem("token"),
          });

          const data = Array.isArray(mswSecondaryInnerReport)
            ? mswSecondaryInnerReport
            : [];

          const totals = data.reduce(
            (acc, row) => ({
              plannedVehicleCount:
                acc.plannedVehicleCount +
                (Number(row.plannedVehicleCount) || 0),
              deployedVehicleCount:
                acc.deployedVehicleCount +
                (Number(row.deployedVehicleCount) || 0),
              deploymentPercentage:
                acc.deploymentPercentage +
                (Number(row.deploymentPercentage) || 0),
              hklVehicleCapacity:
                acc.hklVehicleCapacity + (Number(row.hklVehicleCapacity) || 0),
            }),
            {
              plannedVehicleCount: 0,
              deployedVehicleCount: 0,
              deploymentPercentage: 0,
              hklVehicleCapacity: 0,
            },
          );

          const avgDeploymentPercentage = data.length
            ? (totals.deploymentPercentage / data.length).toFixed(2)
            : 0;

          const totalRow = {
            zoneName: "Total",
            circleName: "",
            plannedVehicleCount: totals.plannedVehicleCount,
            deployedVehicleCount: totals.deployedVehicleCount,
            deploymentPercentage: avgDeploymentPercentage,
            hklVehicleCapacity: totals.hklVehicleCapacity,
          };

          const finalData = data.length ? [...data, totalRow] : data;

          set({
            MSWManagementSecondaryCollectionInnerReportData: finalData,
            loading: false,
            error: null,
          });
        } catch (error) {
          if (error.response) {
            if (error.response.status === 404) {
              toast.error(error.message);
              set({
                MSWManagementSecondaryCollectionInnerReportData: [],
                error: "No Data found.",
                loading: false,
              });
            } else if (error.response.status === 400) {
              toast.error(error.message || "Bad Request");
              set({
                MSWManagementSecondaryCollectionInnerReportData: [],
                error: error.message || "Bad Request",
                loading: false,
              });
            } else if (error.response.status === 401) {
              toast.error("Unauthorized. Please login again.");
              localStorage.removeItem("token");
              set({
                MSWManagementSecondaryCollectionInnerReportData: [],
                error: "Unauthorized",
                loading: false,
              });
              window.location.href = "/login";
            } else if (error.response.status === 500) {
              toast.error("Internal Server Error");
              set({
                MSWManagementSecondaryCollectionInnerReportData: [],
                error: "Internal Server Error",
                loading: false,
              });
            } else {
              toast.error(error.message || "Something went wrong");
              set({
                MSWManagementSecondaryCollectionInnerReportData: [],
                error: error.message || "Something went wrong",
                loading: false,
              });
            }
          } else {
            set({
              MSWManagementSecondaryCollectionInnerReportData: [],
              error: "Network error. Please try again.",
              loading: false,
            });
          }
        } finally {
          set({ loading: false });
        }
      },

      // ================= Monthly Report =================
      fetchMSWManagementMonthlySecondaryCollectionReport: async (
        queryParams,
      ) => {
        set({ loading: true, error: null });
        const queryString = new URLSearchParams(queryParams).toString();

        try {
          const mswSecondaryMonthlyReport = await apiCall({
            url: `${API_BASE_URL1}KpiReport/PlannedAndDeployedSecondaryVehiclesSummaryMonthly?${queryString}`,
            method: "get",
            token: localStorage.getItem("token"),
          });

          set({
            MSWManagementSecondaryCollectionMonthlyReportData: Array.isArray(
              mswSecondaryMonthlyReport,
            )
              ? mswSecondaryMonthlyReport
              : [],
            loading: false,
            error: null,
          });
        } catch (error) {
          if (error.response) {
            if (error.response.status === 404) {
              toast.error(error.message);
              set({
                MSWManagementSecondaryCollectionMonthlyReportData: [],
                error: "No Data found.",
                loading: false,
              });
            } else if (error.response.status === 400) {
              toast.error(error.message || "Bad Request");
              set({
                MSWManagementSecondaryCollectionMonthlyReportData: [],
                error: error.message || "Bad Request",
                loading: false,
              });
            } else if (error.response.status === 401) {
              toast.error("Unauthorized. Please login again.");
              localStorage.removeItem("token");
              set({
                MSWManagementSecondaryCollectionMonthlyReportData: [],
                error: "Unauthorized",
                loading: false,
              });
              window.location.href = "/login";
            } else if (error.response.status === 500) {
              toast.error("Internal Server Error");
              set({
                MSWManagementSecondaryCollectionMonthlyReportData: [],
                error: "Internal Server Error",
                loading: false,
              });
            } else {
              toast.error(error.message || "Something went wrong");
              set({
                MSWManagementSecondaryCollectionMonthlyReportData: [],
                error: error.message || "Something went wrong",
                loading: false,
              });
            }
          } else {
            set({
              MSWManagementSecondaryCollectionMonthlyReportData: [],
              error: "Network error. Please try again.",
              loading: false,
            });
          }
        } finally {
          set({ loading: false });
        }
      },

      // deployed inner report

      MSWDepolyedData: [],
      IsMSWDepolyed: false,

      fetchMSWDepolyedInnerReport: async (queryParams) => {
        set({ IsMSWDepolyed: true });
        const queryString = new URLSearchParams(queryParams).toString();

        try {
          const response = await apiCall({
            url: `${API_BASE_URL1}KpiReport/GetSecondaryVehiclesInnerReport?${queryString}`,
            method: "get",
            token: localStorage.getItem("token"),
          });

          set({
            IsMSWDepolyed: false,
            MSWDepolyedData: response.data,
          });

          return response.data;
        } catch (error) {
          console.log("error", error);
          throw error;
        } finally {
          set({ IsMSWDepolyed: false });
        }
      },
    }),
    {
      name: "kpi5-outer-storage", // localStorage key

      // ✅ Only persist this field
      partialize: (state) => ({
        kpi5outerData: state.kpi5outerData,
      }),
    },
  ),
);

export default MSWManagementSecondaryCollectionStore;
